import {
  Button,
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import { parseImageUrl } from "../../lib/helper";
import { FormInputProps } from "../../models/form.model";
import {
  UploadFile as UploadFileIcon,
  Link as LinkIcon,
} from "@mui/icons-material";
import { upload } from "../../lib/s3upload";

export default function FormInputText(props: FormInputProps & TextFieldProps) {
  const {
    name,
    control,
    helperText,
    readOnly,
    rules,
    setError,
    hasUpload,
    ...rest
  } = props;
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  const [loading, setLoading] = useState(false);
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, value = "" },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          helperText={error ? error.message : helperText || null}
          error={!!error}
          inputRef={props.inputRef}
          onChange={onChange}
          value={value}
          fullWidth
          variant="outlined"
          InputProps={{
            readOnly,
            startAdornment:
              hasUpload && value ? (
                <Button
                  component="a"
                  href={value}
                  target="_blank"
                  startIcon={<LinkIcon />}
                ></Button>
              ) : (
                props.InputProps?.startAdornment
              ),
            endAdornment: hasUpload ? (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle image upload"
                  disabled={loading}
                  edge="end"
                >
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : (
                    <UploadFileIcon />
                  )}
                  <input
                    className="width-100p height-100p pointer"
                    id={`${name}-input`}
                    style={{
                      position: "absolute",
                      opacity: 0,
                      display: loading ? "none" : "block",
                      zIndex: 9,
                    }}
                    accept="image/*"
                    onChange={async (e) => {
                      const files = e.target.files;
                      if (!files) {
                        return;
                      }
                      try {
                        const file = files[0];
                        setLoading(true);
                        onChange({
                          value: window.URL.createObjectURL(file),
                          label: file.name,
                        });
                        const res = await upload({
                          file,
                          prefix: name,
                        });
                        onChange(parseImageUrl(res));
                      } catch (e: any) {
                        setErrorMsg(e.message);
                      } finally {
                        setLoading(false);
                        e.target.value = "";
                      }
                    }}
                    type="file"
                  />
                </IconButton>
              </InputAdornment>
            ) : (
              props.InputProps?.endAdornment
            ),
          }}
          {...rest}
        />
      )}
    />
  );
}
